import { FC } from "react";

import { ITemplateData } from "@framework/types";

import { PieDiagram } from "../pie";

export interface IDiagramSelectorProps {
  data: ITemplateData[];
  size?: string;
  type: string;
}

export const DiagramSelector: FC<IDiagramSelectorProps> = props => {
  const { data, size, type } = props;

  switch (type) {
    case "round3D":
      return <PieDiagram size={size} data={data} />;
    default:
      return null;
  }
};
